"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTooltipTheme = void 0;
var tooltip_rocket_svg_1 = __importDefault(require("../../assets/images/tooltip-rocket.svg"));
exports.createTooltipTheme = function (_a) {
    var palette = _a.palette;
    var textColor = "#0F2440";
    return {
        tooltip: {
            backgroundImage: "url(" + tooltip_rocket_svg_1.default + ")",
            backgroundRepeat: " no-repeat",
            backgroundPosition: "right bottom",
            backgroundSize: "40%",
            backgroundColor: palette.common.white,
            color: textColor,
            fontSize: 16,
            fontFamily: "Gilroy",
            padding: 16,
            boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)",
        },
        arrow: {
            color: palette.common.white,
        },
    };
};
